import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import {repeat} from 'lit/directives/repeat.js';
import store from '../src/store';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { setFollowingDialog } from '../src/store';
import { SldsBaseElement } from '../components/slds-base-element.js';

@customElement('sidebar-component')
class MainView extends connect(store)(SldsBaseElement) {
  @property({type: String}) selected = "main";
  @property({type: String}) category = "";
  @property({type: Array}) pinned = [];
  @property({type: Array}) categories = [];
  @property({type: Array}) following = [];
  @property({type: Array}) recents = [];
  @property({type: Object}) adultMode = false;

  stateChanged(state) {
    if (state.user) {
      this.adultMode = (state.user.adultContent === true);
    }
  }

  constructor() {
    super();
    var self = this;
    requestAnimationFrame(() => {
      self.shadowRoot.getElementById('sidebar').classList.add('appear-animation');
    });
  }

  static styles = [
    super.styles,
    css`
    @keyframes smooth-appear {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    @-webkit-keyframes smooth-appear {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    @-moz-keyframes smooth-appear {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    @-o-keyframes smooth-appear {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    .appear-animation {
      -webkit-animation: smooth-appear 1s ease forwards;
      -moz-animation: smooth-appear 1s ease forwards;
      -o-animation: smooth-appear 1s ease forwards;
      animation: smooth-appear 1s ease forwards;
    }
    #sidebar {
      opacity: 0;
    }
    .slds-nav-vertical__action, .slds-text-title_caps, .slds-form-element__label, .slds-text-heading--label-normal, .slds-text-heading_label-normal, .slds-text-title, #darkmode {
      color: var(--font-color);
    }
    .slds-nav-vertical_shade .slds-is-active .slds-nav-vertical__action {
      border-color: var(--active-border);
    }
    .slds-nav-vertical_shade .slds-is-active.slds-nav-vertical__item:before, .slds-nav-vertical_shade .slds-nav-vertical__item:hover:before {
      background-color: var(--active-background);
    }
    .slds-nav-vertical__item a.slds-truncate {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .stencil span {
      visibility: hidden;
    }
    .stencil:first-child div.slds-tree__item {
      margin-top: 1rem;
    }
    .stencil:last-child div.slds-tree__item {
      margin-bottom: 1rem;
    }
    .stencil div.slds-tree__item {
      background-color: lightgray !important;
      margin: 1rem;
      border-radius: 1rem;
      padding: 0.275rem 0 0.275rem 1rem;
      margin: 1.25rem 1rem;
      cursor: default;
    }
    .slds-button_dual-stateful.slds-is-pressed {
      --slds-c-button-dual-stateful-color-background-selected: transparent !important;
      --slds-c-button-dual-stateful-color-border-selected: transparent !important;
      --sds-c-button-brand-color-background: transparent;
      --sds-c-button-brand-color-border: transparent;
      --slds-c-icon-color-foreground: #0176d3;
      --slds-c-button-brand-spacing-inline-start: 0;
      --slds-c-button-brand-spacing-inline-end: 0;
    }
    `
  ];

  editFollowing(e) {
    e.preventDefault();
    console.log("Edit following");
    store.dispatch(setFollowingDialog(true));
  }

  selectItem(e) {
    e.preventDefault();
    const pinButtonClicked = e.target.closest('.slds-button') || e.target.closest('.slds-button *');
    if (pinButtonClicked) {
      // Handle pin button click
      console.log('Pin button or its child element clicked');
      const currentHref = e.target.closest('a');
      const currentHrefValue = currentHref.href.split("/").pop();
      const alreadyPinned = this.pinned.some(category => category.id === currentHrefValue);
      for (const category of this.categories) {
        if (category.id === currentHrefValue) {
          if (category.pinned) {
            category.pinned = false;
            if (alreadyPinned) {
              this.pinned = this.pinned.filter(pinned => pinned.id !== currentHrefValue);
            }
            this.requestUpdate();
          }
          else {
            category.pinned = true;
            if (!alreadyPinned) {
              this.pinned = [...this.pinned, category];
            }
            this.requestUpdate();
          }
          break;
        }
      }
      return;
    }
    if (e.target.tagName === 'A') {
      this.selected = e.target.href;
    } else {
      const parentLink = e.target.closest('a');
      if (parentLink) {
        this.selected = parentLink.href;
      }
    }
    if (this.selected === "") {
      this.selected = "/";
    }
    history.pushState({}, null, this.selected);
    window.dispatchEvent(new CustomEvent('route'));
    this.dispatchEvent(new CustomEvent('close'));
  }

  render() {
    return html`
        <div id="sidebar">
          <nav class="slds-nav-vertical slds-nav-vertical_shade" aria-label="Menu">
            <div class="slds-nav-vertical__section">
              <h2 id="entity-header" class="slds-nav-vertical__title slds-text-title_caps">Menu</h2>
              <ul aria-describedby="entity-header">
                <li class="slds-nav-vertical__item ${(this.category==="" && this.selected==="main")?"slds-is-active":""}">
                  <a href="/" @click=${this.selectItem} class="slds-nav-vertical__action" ?aria-current="${this.selected === "main"}"><svg class="slds-icon slds-icon-text-default slds-icon_x-small slds-m-right_x-small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#home"></use>
                </svg>Home</a>
                </li>
                <li class="slds-nav-vertical__item ${(this.category==="" && this.selected==="top")?"slds-is-active":""}">
                  <a href="/top" @click=${this.selectItem} class="slds-nav-vertical__action" ?aria-current="${this.selected === "top"}"><svg class="slds-icon slds-icon-text-default slds-icon_x-small slds-m-right_x-small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#watchlist"></use>
                </svg>Top</a>
                </li>
                <li class="slds-nav-vertical__item ${(this.category==="" && this.selected==="trending")?"slds-is-active":""}">
                  <a href="/trending" @click=${this.selectItem} class="slds-nav-vertical__action" ?aria-current="${this.selected === "trending"}"><svg class="slds-icon slds-icon-text-default slds-icon_x-small slds-m-right_x-small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#trending"></use>
                </svg>Trending</a>
                </li>
                <li class="slds-nav-vertical__item ${(this.category==="" && this.selected==="fresh")?"slds-is-active":""}">
                  <a href="/fresh" @click=${this.selectItem} class="slds-nav-vertical__action" ?aria-current="${this.selected === "fresh"}"><svg class="slds-icon slds-icon-text-default slds-icon_x-small slds-m-right_x-small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#clock"></use>
                </svg>Fresh</a>
                </li>
              </ul>
            </div>
            ${this.recents.length > 0 ? html`
            <div class="slds-nav-vertical__section">
              <h2 id="folder-header" class="slds-nav-vertical__title">Recents</h2>
              <ul aria-describedby="folder-header">
                ${this.recents.map(post => html`
                <li class="slds-nav-vertical__item">
                  <a href="/post/${post.id}" @click=${this.selectItem} class="slds-nav-vertical__action">
                    <img src="${category.icon}" alt="${category.title}" class="slds-avatar slds-avatar_small slds-m-right_x-small" />
                    ${category.title}
                    <button class="slds-button slds-button_icon slds-button_icon-small slds-button_dual-stateful slds-col_bump-left ${category.pinned?"slds-is-pressed":""}" aria-live="assertive" aria-pressed="${category.pinned}">
                      <span class="slds-text-not-pressed">
                        <svg class="slds-button__icon slds-button__icon_small" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#pin"></use>
                        </svg>
                        <span class="slds-assistive-text">Pin</span>
                      </span>
                      <span class="slds-text-pressed">
                        <svg class="slds-button__icon slds-button__icon_medium" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#pinned"></use>
                        </svg>
                        <span class="slds-assistive-text">Pinned</span>
                      </span>
                    </button>
                  </a>
                </li>
                `)}
              </ul>
            </div>` : ''}
            ${this.pinned.length > 0 ? html`
            <div class="slds-nav-vertical__section slds-m-bottom_medium">
              <h2 id="folder-header" class="slds-nav-vertical__title">Pinned</h2>
              <ul aria-describedby="folder-header">
                ${this.pinned.map(category => html`
                <li class="slds-nav-vertical__item ${this.category===category.id?"slds-is-active":""}">
                  <a href="/interest/${category.id}" @click=${this.selectItem} class="slds-nav-vertical__action">
                    <img src="${category.icon}" alt="${category.title}" class="slds-avatar slds-avatar_small slds-m-right_x-small" />
                    ${category.title}
                    <button class="slds-button slds-button_icon slds-button_icon-small slds-button_dual-stateful slds-col_bump-left ${category.pinned?"slds-is-pressed":""}" aria-live="assertive" aria-pressed="${category.pinned}">
                      <span class="slds-text-not-pressed">
                        <svg class="slds-button__icon slds-button__icon_small" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#pin"></use>
                        </svg>
                        <span class="slds-assistive-text">Pin</span>
                      </span>
                      <span class="slds-text-pressed">
                        <svg class="slds-button__icon slds-button__icon_medium" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#pinned"></use>
                        </svg>
                        <span class="slds-assistive-text">Pinned</span>
                      </span>
                    </button>
                  </a>
                </li>
                `)}
              </ul>
            </div>
            ` : ''}
            <div class="slds-nav-vertical__section">
              <h2 id="folder-header" class="slds-nav-vertical__title">Following <a href="#" @click=${this.editFollowing} class="slds-text-link slds-float_right">Edit</a></h2>
              <ul aria-describedby="folder-header">
                ${this.following.map(category => html`
                <li class="slds-nav-vertical__item ${this.category===category.id?"slds-is-active":""}">
                  <a href="/interest/${category.id}" @click=${this.selectItem} class="slds-nav-vertical__action">
                    <img src="${category.icon}" alt="${category.title}" class="slds-avatar slds-avatar_small slds-m-right_x-small" />
                    ${category.title}
                    <button class="slds-button slds-button_icon slds-button_icon-small slds-button_dual-stateful slds-col_bump-left ${category.pinned?"slds-is-pressed":""}" aria-live="assertive" aria-pressed="${category.pinned}">
                      <span class="slds-text-not-pressed">
                        <svg class="slds-button__icon slds-button__icon_small" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#pin"></use>
                        </svg>
                        <span class="slds-assistive-text">Pin</span>
                      </span>
                      <span class="slds-text-pressed">
                        <svg class="slds-button__icon slds-button__icon_medium" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#pinned"></use>
                        </svg>
                        <span class="slds-assistive-text">Pinned</span>
                      </span>
                    </button>
                  </a>
                </li>
                `)}
              </ul>
            </div>
            <div class="slds-nav-vertical__section slds-m-bottom_medium">
              <h2 id="folder-header" class="slds-nav-vertical__title">Interests</h2>
              <ul aria-describedby="folder-header">
                ${this.categories.filter(category => !category.onlyPost && (!category.adultContent || this.adultMode)).map(category => html`
                <li class="slds-nav-vertical__item ${this.category===category.id?"slds-is-active":""}">
                  <a href="/interest/${category.id}" @click=${this.selectItem} class="slds-nav-vertical__action">
                    <img src="${category.icon}" alt="${category.title}" class="slds-avatar slds-avatar_small slds-m-right_x-small" />
                    ${category.title}
                    <button class="slds-button slds-button_icon slds-button_icon-small slds-button_dual-stateful slds-col_bump-left ${category.pinned?"slds-is-pressed":""}" aria-live="assertive" aria-pressed="${category.pinned}">
                      <span class="slds-text-not-pressed">
                        <svg class="slds-button__icon slds-button__icon_small" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#pin"></use>
                        </svg>
                        <span class="slds-assistive-text">Pin</span>
                      </span>
                      <span class="slds-text-pressed">
                        <svg class="slds-button__icon slds-button__icon_medium" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#pinned"></use>
                        </svg>
                        <span class="slds-assistive-text">Pinned</span>
                      </span>
                    </button>
                  </a>
                </li>
                `)}
              </ul>
            </div>
          </nav>
        </div>
    `
  }
}